<template>
  <div class="hero">
    <div class="hero-content">
      <h1>电技95 · 三十载重逢</h1>
      <p class="hero-subtitle">中国矿业大学 · 电气技术与自动化 1995级</p>
      <div class="hero-accent"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Hero'
}
</script>

<style scoped>
.hero {
  background: linear-gradient(135deg, #005BAF 0%, #003D7A 100%);
  padding: 60px 20px;
  text-align: center;
  color: white;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><text y=".9em" font-size="40">⚡</text></svg>') repeat;
  opacity: 0.05;
  pointer-events: none;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero h1 {
  font-size: 36px;
  margin: 0 0 15px 0;
  font-weight: 700;
  letter-spacing: 2px;
}

.hero-subtitle {
  font-size: 18px;
  margin: 0;
  opacity: 0.95;
  font-weight: 400;
}

.hero-accent {
  width: 60px;
  height: 4px;
  background: #FFB800;
  margin: 20px auto 0;
  border-radius: 2px;
}

@media (max-width: 768px) {
  .hero {
    padding: 40px 20px;
  }
  
  .hero h1 {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 15px;
  }
}
</style>
